import IconSort from "../../common/components/icons/IconSort";
import useTranslation from "../../common/translations";
import { DEFAULT_SORT, SORT_OPTIONS, SORT_PARAM } from "../constants";
import { useOfferFiltersDispatch, useOfferFiltersState, } from "../context/OfferFiltersContext";
import { useOfferFilterSubmit } from "../hooks/useOfferFilterSubmit";
import DesktopFilterPopover from "./DesktopFilterPopover";
import React from "react";
export default function SortDropdown() {
    var _a;
    const { t } = useTranslation("offer-filters");
    const { selectedState } = useOfferFiltersState();
    const dispatch = useOfferFiltersDispatch();
    const submitFilters = useOfferFilterSubmit();
    const currentSort = String((_a = selectedState[SORT_PARAM]) !== null && _a !== void 0 ? _a : DEFAULT_SORT);
    return (<DesktopFilterPopover placement="bottom-end" onSubmit={submitFilters} trigger={({ ref, toggle }) => (<button ref={ref} type="button" aria-label={t("sort.label")} onClick={toggle} className="flex items-center justify-center h-10 w-10 rounded-full border border-[#A1A2A5] bg-white text-[#1C2022]">
          <IconSort />
        </button>)}>
      {SORT_OPTIONS.map((option) => (<label key={option.value} className="flex items-center gap-3 py-2 cursor-pointer">
          <input type="radio" name="sort-desktop" value={option.value} checked={currentSort === option.value} onChange={() => dispatch({ type: "set_sort", payload: option.value === DEFAULT_SORT ? undefined : option.value })} className="rounded-full border-[#0C191D] size-[18px] text-black focus:ring-0 focus:ring-offset-0 cursor-pointer"/>
          <span className="text-gray-900">{t(option.labelKey)}</span>
        </label>))}
    </DesktopFilterPopover>);
}
